(function(){
  if(window.nuvantaRoundedHeaderVersion!=='6'){
    window.nuvantaRoundedHeader=function(scope){
      var roots=scope.matches&&scope.matches('[data-nv-header]')?[scope]:scope.querySelectorAll('[data-nv-header]');
      roots.forEach(function(root){
        if(root.dataset.nvReady==='6')return;
        if(root.nvDisconnect)root.nvDisconnect();
        root.dataset.nvReady='6';
        var controller=new AbortController();
        var lang=document.documentElement.lang.indexOf('en')===0?'en':'es';
        var languageButton=root.querySelector('.nvh-language');
        var menu=root.querySelector('details');
        var spacer=root.previousElementSibling;
        var atTop=window.scrollY<=24;
        var frame=0;
        function sizeSpacer(){if(spacer&&spacer.hasAttribute('data-nv-header-spacer'))spacer.style.height=root.getBoundingClientRect().height+'px'}
        function refreshScroll(){
          frame=0;
          if(!root.isConnected)return;
          if(atTop&&window.scrollY>64)atTop=false;
          else if(!atTop&&window.scrollY<=24)atTop=true;
          root.classList.toggle('nvh-at-top',atTop);
        }
        function onScroll(){if(!frame)frame=requestAnimationFrame(refreshScroll)}
        refreshScroll();
        sizeSpacer();
        window.addEventListener('scroll',onScroll,{passive:true,signal:controller.signal});
        window.addEventListener('resize',sizeSpacer,{passive:true,signal:controller.signal});
        var sizeObserver=typeof ResizeObserver==='function'?new ResizeObserver(sizeSpacer):null;
        if(sizeObserver)sizeObserver.observe(root);
        function update(next){
          lang=next;
          root.querySelectorAll('[data-nv-es]').forEach(function(el){el.textContent=el.getAttribute('data-nv-'+lang)});
          languageButton.innerHTML=lang==='es'?'ES <span>/ EN</span>':'EN <span>/ ES</span>';
          languageButton.setAttribute('aria-label',lang==='es'?'Cambiar idioma a inglés':'Change language to Spanish');
        }
        update(lang);
        languageButton.addEventListener('click',function(){
          var next=lang==='es'?'en':'es';
          var nativeButton=Array.from(document.querySelectorAll('#nuvanta-root .language')).find(function(el){return !root.contains(el)});
          if(nativeButton){
            if(document.documentElement.lang!==next)nativeButton.click();
          }else{
            document.documentElement.lang=next;
            document.querySelectorAll('[data-en][data-es]').forEach(function(el){el.innerHTML=el.dataset[next]});
            try{localStorage.setItem('nuvanta-language',next)}catch(e){}
          }
          update(next);
        });
        root.querySelectorAll('a').forEach(function(link){
          link.addEventListener('click',function(){menu.open=false},{signal:controller.signal});
          if(link.getAttribute('href')===window.location.pathname)link.setAttribute('aria-current','page');
        });
        root.addEventListener('keydown',function(event){if(event.key==='Escape'){menu.open=false;root.querySelector('summary').focus()}});
        var observer=new MutationObserver(function(){update(document.documentElement.lang.indexOf('en')===0?'en':'es')});
        observer.observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
        root.nvDisconnect=function(){controller.abort();observer.disconnect();if(sizeObserver)sizeObserver.disconnect();window.removeEventListener('scroll',onScroll);window.removeEventListener('resize',sizeSpacer);if(frame)cancelAnimationFrame(frame)};
      });
    };
    window.nuvantaRoundedHeaderVersion='6';
    document.addEventListener('shopify:section:load',function(event){window.nuvantaRoundedHeader(event.target)});
    document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-nv-header]').forEach(function(root){if(root.nvDisconnect)root.nvDisconnect()})});
  }
  window.nuvantaRoundedHeader(document);
})();
;
(function(){
  function setup(scope){
    var roots=scope.matches&&scope.matches('[data-nv-cube]')?[scope]:scope.querySelectorAll('[data-nv-cube]');
    roots.forEach(function(root){
      if(root.dataset.nvcVersion==='3')return;
      if(root.nvcCleanup)root.nvcCleanup();
      root.dataset.nvcVersion='3';
      var controller=new AbortController(),signal=controller.signal;
      var cube=root.querySelector('.nvc-object'),scene=root.querySelector('.nvc-scene'),play=root.querySelector('[data-nvc-play]');
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      var running=!reduced.matches,visible=true,drag=null,x=-18,y=-25,frame=0,last=0;
      cube.style.transition='none';
      function render(){cube.style.transform='rotateX('+x+'deg) rotateY('+y+'deg)'}
      function label(){play.textContent=running?'Pausar giro':'Activar giro';play.setAttribute('aria-pressed',String(!running))}
      function allowed(){return running&&visible&&!document.hidden&&!drag&&root.isConnected}
      function schedule(){if(!frame&&allowed())frame=requestAnimationFrame(tick)}
      function freeze(){if(frame)cancelAnimationFrame(frame);frame=0;last=0}
      function tick(time){
        frame=0;
        if(!allowed()){last=0;return}
        var delta=last?Math.min((time-last)/1000,.05):0;
        last=time;
        x=(x-delta*5)%360;
        y=(y-delta*14)%360;
        render();
        schedule();
      }
      function stop(){running=false;freeze();label()}
      function start(){running=true;last=0;label();schedule()}
      function visibility(){freeze();schedule()}
      play.addEventListener('click',function(){if(running)stop();else start()},{signal:signal});
      scene.addEventListener('keydown',function(event){
        if(['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].indexOf(event.key)===-1)return;
        event.preventDefault();
        if(event.key==='ArrowLeft')y+=30;
        if(event.key==='ArrowRight')y-=30;
        if(event.key==='ArrowUp')x+=30;
        if(event.key==='ArrowDown')x-=30;
        render();
      },{signal:signal});
      cube.addEventListener('pointerdown',function(event){
        if(event.pointerType==='mouse'&&event.button!==0)return;
        if(drag)return;
        freeze();
        drag={id:event.pointerId,startX:event.clientX,startY:event.clientY,x:x,y:y,moved:false};
        cube.setPointerCapture(event.pointerId);
      },{signal:signal});
      cube.addEventListener('pointermove',function(event){
        if(!drag||drag.id!==event.pointerId)return;
        var dx=event.clientX-drag.startX,dy=event.clientY-drag.startY;
        if(Math.abs(dx)+Math.abs(dy)>4)drag.moved=true;
        x=drag.x-dy*.5;
        y=drag.y+dx*.5;
        render();
      },{signal:signal});
      function endDrag(event){
        if(!drag)return;
        if(event.pointerId!==drag.id)return;
        if(event.type==='pointerup'&&!drag.moved){y-=90;render()}
        drag=null;
        last=0;
        schedule();
      }
      cube.addEventListener('pointerup',endDrag,{signal:signal});
      cube.addEventListener('pointercancel',endDrag,{signal:signal});
      cube.addEventListener('lostpointercapture',endDrag,{signal:signal});
      document.addEventListener('visibilitychange',visibility,{signal:signal});
      var observer=typeof IntersectionObserver==='function'?new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;visibility()},{threshold:0}):null;
      if(observer)observer.observe(root);
      reduced.addEventListener('change',function(){if(reduced.matches)stop()},{signal:signal});
      render();label();schedule();
      root.nvcCleanup=function(){freeze();controller.abort();if(observer)observer.disconnect();delete root.nvcCleanup;delete root.dataset.nvcVersion};
    });
  }
  window.nuvantaTrustCubeSetup=setup;
  setup(document);
  if(!window.nuvantaTrustCubeEvents){
    window.nuvantaTrustCubeEvents=true;
    document.addEventListener('shopify:section:load',function(event){window.nuvantaTrustCubeSetup(event.target)});
    document.addEventListener('shopify:section:unload',function(event){var roots=event.target.matches('[data-nv-cube]')?[event.target]:event.target.querySelectorAll('[data-nv-cube]');roots.forEach(function(root){if(root.nvcCleanup)root.nvcCleanup()})});
  }
})();
;
(() => {
  const init = (scope) => {
    const roots = [...scope.querySelectorAll('[data-nimp]')];
    if (scope.matches && scope.matches('[data-nimp]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.nimpReady || !('IntersectionObserver' in window)) return;
      root.dataset.nimpReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cards = [...root.querySelectorAll('.nimp__card')];
      const targets = [...cards,root.querySelector('.nimp__review')];
      const animations = new Set();
      const number = root.querySelector('.nimp__day strong');
      let countFrame = 0;
      let repeatTimer = 0;
      let numberVisible = false;
      let numberPulse = null;
      const stopCounter = () => {
        clearTimeout(repeatTimer);
        repeatTimer = 0;
        if (countFrame) cancelAnimationFrame(countFrame);
        countFrame = 0;
        if (numberPulse) { numberPulse.cancel(); animations.delete(numberPulse); numberPulse = null; }
        if (number) number.textContent = '30';
      };
      const allowed = () => number && numberVisible && !document.hidden && !reduced.matches && root.isConnected;
      const startCounter = () => {
        stopCounter();
        if (!allowed()) return;
        const started = performance.now();
        number.textContent = '0';
        const count = (time) => {
          countFrame = 0;
          if (!allowed()) { stopCounter(); return; }
          const progress = Math.min(1, Math.max(0, (time - started) / 1600));
          const eased = 1 - Math.pow(1 - progress, 3);
          number.textContent = String(Math.floor(30 * eased));
          if (progress < 1) countFrame = requestAnimationFrame(count);
          else {
            number.textContent = '30';
            if (number.animate) {
              const finish = number.animate([{transform:'scale(1)'},{transform:'scale(1.035)',offset:.4},{transform:'scale(1)'}],{duration:600,easing:'cubic-bezier(.22,1,.36,1)'});
              numberPulse = finish;
              animations.add(finish);
              finish.onfinish = () => { animations.delete(finish); if (numberPulse === finish) numberPulse = null; };
            }
          }
        };
        countFrame = requestAnimationFrame(count);
        repeatTimer = setTimeout(startCounter,5000);
      };
      const synchronizeCounter = () => { if (allowed()) startCounter(); else stopCounter(); };
      const countObserver = number ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          numberVisible = entry.isIntersecting && entry.intersectionRatio >= .55;
          synchronizeCounter();
        });
      },{threshold:.55}) : null;
      if (countObserver) countObserver.observe(number);
      document.addEventListener('visibilitychange',synchronizeCounter);
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (!reduced.matches && entry.target.animate) {
            const columns = window.innerWidth >= 1050 ? 3 : window.innerWidth >= 700 ? 2 : 1;
            const index = cards.indexOf(entry.target);
            const motion = entry.target.animate([{opacity:.4,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}],{duration:750,easing:'cubic-bezier(.22,1,.36,1)',delay:index >= 0 ? index%columns*70 : 0});
            animations.add(motion);
            motion.onfinish = () => animations.delete(motion);
          }
          observer.unobserve(entry.target);
        });
      },{threshold:.12});
      targets.forEach((target) => observer.observe(target));
      const stop = () => { if (reduced.matches) { animations.forEach((motion) => motion.cancel()); animations.clear(); } synchronizeCounter(); };
      reduced.addEventListener('change',stop);
      const unload = (event) => {
        if (event.target !== root && !event.target.contains(root)) return;
        observer.disconnect();
        if (countObserver) countObserver.disconnect();
        stopCounter();
        document.removeEventListener('visibilitychange',synchronizeCounter);
        animations.forEach((motion) => motion.cancel());
        reduced.removeEventListener('change',stop);
        document.removeEventListener('shopify:section:unload',unload);
      };
      document.addEventListener('shopify:section:unload',unload);
    });
  };
  init(document);
  if (!window.nuvantaImpulsoBound) {
    window.nuvantaImpulsoBound = true;
    document.addEventListener('shopify:section:load',(event) => init(event.target));
  }
})();
;
(function(){
  if(!window.nuvantaStorePreviewInit){
    window.nuvantaStorePreviewInit=function(scope){
      const roots=Array.from(scope.querySelectorAll('[data-nvt]'));
      if(scope.matches&&scope.matches('[data-nvt]'))roots.push(scope);
      roots.forEach(function(root){
        if(root.nvtCleanup)return;
        const heart=root.querySelector('[data-nvt-heart]');
        const cart=root.querySelector('[data-nvt-cart]');
        const label=root.querySelector('[data-nvt-cart-label]');
        const message=root.querySelector('[data-nvt-message]');
        const events=new AbortController();
        let timer=0;
        heart.disabled=false;cart.disabled=false;
        heart.addEventListener('click',function(){
          const saved=heart.getAttribute('aria-pressed')!=='true';
          heart.setAttribute('aria-pressed',String(saved));
          message.textContent=saved?'Favorito guardado en esta demostración.':'Favorito eliminado de la demostración.';
        },{signal:events.signal});
        cart.addEventListener('click',function(){
          clearTimeout(timer);
          label.textContent='Añadido ✓';
          message.textContent='Vista previa: producto añadido al carrito.';
          timer=setTimeout(function(){label.textContent='Añadir al carrito';},2600);
        },{signal:events.signal});
        root.nvtCleanup=function(){clearTimeout(timer);events.abort();delete root.nvtCleanup;};
      });
    };
    document.addEventListener('shopify:section:load',function(event){window.nuvantaStorePreviewInit(event.target);});
    document.addEventListener('shopify:section:unload',function(event){
      const roots=Array.from(event.target.querySelectorAll('[data-nvt]'));
      if(event.target.matches&&event.target.matches('[data-nvt]'))roots.push(event.target);
      roots.forEach(function(root){if(root.nvtCleanup)root.nvtCleanup();});
    });
  }
  window.nuvantaStorePreviewInit(document);
})();
;
(function(){
  if(!window.nuvantaReferenceInit){
    window.nuvantaReferenceInit=function(root){
      if(root.nvrCleanup)return;
      var abort=new AbortController(),signal=abort.signal;
      var cards=Array.from(root.querySelectorAll('[data-nvr-card]'));
      var filters=Array.from(root.querySelectorAll('[data-nvr-filter]'));
      var videos=Array.from(root.querySelectorAll('[data-nvr-video]'));
      var motion=root.querySelector('[data-nvr-motion]'),status=root.querySelector('[data-nvr-status]');
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      var paused=reduced.matches,inView=new Map(),manualPause=new Map(),animations=[];
      var viewportObserver=null,entryObserver=null;
      root.querySelector('[data-nvr-toolbar]').hidden=false;
      function renderMotion(){
        motion.setAttribute('aria-pressed',String(paused));
        motion.innerHTML=paused?'Reproducir videos <span aria-hidden="true">▶</span>':'Pausar videos <span aria-hidden="true">Ⅱ</span>';
      }
      function syncButton(video){
        var button=video.parentElement.querySelector('[data-nvr-play]');
        var name=video.closest('[data-nvr-card]').querySelector('.nvr__name').textContent;
        button.setAttribute('aria-label',(video.paused?'Reproducir video de ':'Pausar video de ')+name);
        button.querySelector('[data-nvr-symbol]').textContent=video.paused?'▶':'Ⅱ';
      }
      function attemptPlay(video){
        if(signal.aborted)return;
        var promise=video.play();
        if(promise&&promise.catch)promise.catch(function(){syncButton(video)});
      }
      function reconcile(){
        videos.forEach(function(video){
          var card=video.closest('[data-nvr-card]');
          if(!paused&&!manualPause.get(video)&&inView.get(video)&&!card.hidden&&!document.hidden)attemptPlay(video);
          else video.pause();
          syncButton(video);
        });
        renderMotion();
      }
      videos.forEach(function(video){
        video.controls=false;video.muted=true;
        var button=video.parentElement.querySelector('[data-nvr-play]');button.hidden=false;
        button.addEventListener('click',function(){
          if(video.paused){manualPause.set(video,false);attemptPlay(video)}
          else{manualPause.set(video,true);video.pause()}
          syncButton(video);
        },{signal:signal});
        video.addEventListener('play',function(){syncButton(video)},{signal:signal});
        video.addEventListener('pause',function(){syncButton(video)},{signal:signal});
        video.addEventListener('timeupdate',function(){
          var progress=video.parentElement.querySelector('[data-nvr-progress]');
          progress.style.transform='scaleX('+(video.duration?video.currentTime/video.duration:0)+')';
        },{signal:signal});
        video.addEventListener('error',function(){
          button.hidden=true;video.controls=true;
        },{signal:signal});
      });
      if('IntersectionObserver' in window){
        viewportObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){inView.set(entry.target,entry.isIntersecting)});reconcile();
        },{threshold:.18});
        videos.forEach(function(video){viewportObserver.observe(video)});
        entryObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              var index=cards.indexOf(entry.target);
              if(!reduced.matches&&entry.target.animate){
                animations.push(entry.target.animate([{opacity:0,transform:'translateY(28px)'},{opacity:1,transform:'translateY(0)'}],{duration:750,delay:Math.max(0,index)*100,easing:'cubic-bezier(.22,1,.36,1)'}));
              }
              entryObserver.unobserve(entry.target);
            }
          });
        },{threshold:.08});
        cards.forEach(function(card){entryObserver.observe(card)});
      }else{videos.forEach(function(video){inView.set(video,true)});reconcile()}
      filters.forEach(function(button){
        button.addEventListener('click',function(){
          var category=button.getAttribute('data-nvr-filter');
          animations.forEach(function(animation){animation.cancel()});animations=[];
          filters.forEach(function(filter){filter.setAttribute('aria-pressed',String(filter===button))});
          root.setAttribute('data-nvr-filtered',String(category!=='all'));
          var count=0;
          cards.forEach(function(card){
            card.hidden=category!=='all'&&card.getAttribute('data-nvr-card')!==category;
            if(!card.hidden){
              if(!reduced.matches&&card.animate)animations.push(card.animate([{opacity:0,transform:'translateY(15px)'},{opacity:1,transform:'translateY(0)'}],{duration:440,delay:count*65,easing:'cubic-bezier(.22,1,.36,1)'}));
              count++;
            }
          });
          status.textContent=count+(count===1?' referencia disponible.':' referencias disponibles.');reconcile();
        },{signal:signal});
      });
      motion.addEventListener('click',function(){
        paused=!paused;
        if(!paused)videos.forEach(function(video){manualPause.set(video,false)});
        reconcile();
      },{signal:signal});
      reduced.addEventListener('change',function(){
        if(reduced.matches){paused=true;animations.forEach(function(animation){animation.cancel()})}
        reconcile();
      },{signal:signal});
      document.addEventListener('visibilitychange',reconcile,{signal:signal});
      status.textContent='3 referencias disponibles.';
      renderMotion();
      root.nvrCleanup=function(){
        abort.abort();if(viewportObserver)viewportObserver.disconnect();if(entryObserver)entryObserver.disconnect();
        animations.forEach(function(animation){animation.cancel()});videos.forEach(function(video){video.pause();video.controls=true});
        cards.forEach(function(card){card.hidden=false});root.removeAttribute('data-nvr-filtered');
        filters.forEach(function(filter,index){filter.setAttribute('aria-pressed',String(index===0))});
        delete root.nvrCleanup;
      };
    };
    document.addEventListener('shopify:section:load',function(event){
      if(event.target.matches&&event.target.matches('[data-nvr]'))window.nuvantaReferenceInit(event.target);
      event.target.querySelectorAll('[data-nvr]').forEach(window.nuvantaReferenceInit);
    });
    document.addEventListener('shopify:section:unload',function(event){
      if(event.target.nvrCleanup)event.target.nvrCleanup();
      event.target.querySelectorAll('[data-nvr]').forEach(function(root){if(root.nvrCleanup)root.nvrCleanup()});
    });
  }
  document.querySelectorAll('[data-nvr]').forEach(window.nuvantaReferenceInit);
})();
;
(function(){
  if(!window.nuvantaBrandProfilesInit){
    window.nuvantaBrandProfilesInit=function(root){
      if(root.nvbProfilesCleanup)return;
      var controller=new AbortController(),signal=controller.signal;
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      var items=Array.from(root.querySelectorAll('[data-nvb-item]')),observer=null,animations=[];
      var details=root.querySelector('[data-nvb-more]');
      var dialog=root.querySelector('[data-nvb-dialog]'),shell=dialog.querySelector('.nvb__dialog-shell');
      var closeButton=dialog.querySelector('[data-nvb-close]'),opener=null,motion=null,closing=false;
      function reveal(item,index){
        if(reduced.matches||!item.animate)return;
        animations.push(item.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,delay:(index%5)*65,easing:'cubic-bezier(.22,1,.36,1)'}));
      }
      if('IntersectionObserver' in window){
        observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){reveal(entry.target,items.indexOf(entry.target));observer.unobserve(entry.target)}})},{threshold:.25});
        items.forEach(function(item){observer.observe(item)});
      }
      function close(){
        if(!dialog.open||closing)return;
        closing=true;if(motion)motion.cancel();
        function finish(){dialog.close();closing=false}
        if(reduced.matches||!shell.animate){finish();return}
        motion=shell.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(12px)'}],{duration:170,easing:'ease-in'});
        motion.onfinish=finish;
      }
      root.querySelectorAll('[data-nvb-brand]').forEach(function(link){
        link.addEventListener('click',function(event){
          if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0||!dialog.showModal)return;
          var profile=root.querySelector('template[data-nvb-profile="'+link.dataset.nvbBrand+'"]');
          if(!profile)return;
          event.preventDefault();opener=link;closing=false;
          dialog.querySelector('[data-nvb-title]').textContent=link.querySelector('.nvb__mark').textContent;
          dialog.querySelector('[data-nvb-content]').replaceChildren(profile.content.cloneNode(true));
          dialog.querySelector('[data-nvb-visit]').href=link.href;
          dialog.showModal();dialog.scrollTop=0;closeButton.focus({preventScroll:true});
          if(motion)motion.cancel();
          if(!reduced.matches&&shell.animate)motion=shell.animate([{opacity:0,transform:'translateY(24px) scale(.98)'},{opacity:1,transform:'translateY(0) scale(1)'}],{duration:420,easing:'cubic-bezier(.22,1,.36,1)'});
        },{signal:signal});
      });
      closeButton.addEventListener('click',close,{signal:signal});
      dialog.addEventListener('cancel',function(event){event.preventDefault();close()},{signal:signal});
      var backdropPress=false;
      dialog.addEventListener('pointerdown',function(event){backdropPress=event.target===dialog},{signal:signal});
      dialog.addEventListener('click',function(event){if(backdropPress&&event.target===dialog)close();backdropPress=false},{signal:signal});
      dialog.addEventListener('close',function(){closing=false;if(opener&&opener.isConnected)opener.focus({preventScroll:true})},{signal:signal});
      details.addEventListener('toggle',function(){if(!details.open)animations.forEach(function(animation){animation.cancel()})},{signal:signal});
      reduced.addEventListener('change',function(){if(reduced.matches){animations.forEach(function(animation){animation.cancel()});if(motion)motion.cancel();if(closing){dialog.close();closing=false}}},{signal:signal});
      root.nvbProfilesCleanup=function(){controller.abort();if(observer)observer.disconnect();animations.forEach(function(animation){animation.cancel()});if(motion)motion.cancel();if(dialog.open)dialog.close();delete root.nvbProfilesCleanup};
    };
    document.addEventListener('shopify:section:load',function(event){if(event.target.matches&&event.target.matches('[data-nvb]'))window.nuvantaBrandProfilesInit(event.target);event.target.querySelectorAll('[data-nvb]').forEach(window.nuvantaBrandProfilesInit)});
    document.addEventListener('shopify:section:unload',function(event){if(event.target.nvbProfilesCleanup)event.target.nvbProfilesCleanup();event.target.querySelectorAll('[data-nvb]').forEach(function(root){if(root.nvbProfilesCleanup)root.nvbProfilesCleanup()})});
  }
  document.querySelectorAll('[data-nvb]').forEach(window.nuvantaBrandProfilesInit);
})();
;
(function(){
  if(!window.nuvantaCodeInit){
    window.nuvantaCodeInit=function(scope){
      const roots=Array.from(scope.querySelectorAll('[data-nvi]'));
      if(scope.matches&&scope.matches('[data-nvi]'))roots.unshift(scope);
      roots.forEach(function(root){
        if(root.nviCleanup)return;
        const code=root.querySelector('[data-nvi-code]');
        const pre=root.querySelector('.nvi__pre');
        const status=root.querySelector('[data-nvi-status]');
        const pause=root.querySelector('[data-nvi-pause]');
        const replay=root.querySelector('[data-nvi-replay]');
        const controls=root.querySelector('[data-nvi-controls]');
        const source=code.textContent;
        const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
        const events=new AbortController();
        let observer=null,frame=0,last=0,budget=0,index=0,visible=false,started=false,paused=false,destroyed=false;
        const tokens=[];
        const pattern=/("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*')|\b(const|function|return|export)\b|\b([A-Za-z_$][\w$]*)(?=\s*:)|\b([A-Za-z_$][\w$]*)(?=\s*\()/g;
        let previous=0,match;
        function token(text,kind){
          const node=kind?document.createElement('span'):document.createTextNode('');
          if(kind)node.className='nvi__'+kind;
          tokens.push({text: text,node: node,start:previous,end:previous+text.length});
          previous+=text.length;
        }
        let position=0;
        while((match=pattern.exec(source))!==null){
          if(match.index>position)token(source.slice(position,match.index),'');
          token(match[0],match[1]?'string':match[2]?'keyword':match[3]?'property':'function');
          position=pattern.lastIndex;
        }
        if(position < source.length)token(source.slice(position),'');
        code.replaceChildren(...tokens.map(function(item){return item.node;}));
        function paint(){
          tokens.forEach(function(item){
            const text=item.text.slice(0,Math.max(0,Math.min(item.text.length,index-item.start)));
            if(item.node.textContent!==text)item.node.textContent=text;
          });
          pre.scrollTop=pre.scrollHeight;
        }
        function stop(){cancelAnimationFrame(frame);frame=0;last=0;}
        function labels(){
          const complete=index>=source.length;
          root.dataset.nviState=complete?'complete':paused?'paused':started?'typing':'waiting';
          pause.disabled=complete;
          pause.textContent=complete?'Listo':paused?'Continuar':'Pausar';
          status.textContent=complete?'Ideas que toman forma.':paused?'Escritura en pausa.':started?'Construyendo tu próximo paso…':'Listo para comenzar.';
        }
        function tick(time){
          frame=0;
          if(destroyed||paused||!visible||document.hidden||index>=source.length||!root.isConnected){last=0;return;}
          if(last)budget+=Math.min(time-last,100);
          last=time;
          const count=Math.floor(budget/22);
          if(count){budget-=count*22;index=Math.min(source.length,index+count);paint();}
          if(index < source.length)frame=requestAnimationFrame(tick);
          else{stop();labels();}
        }
        function resume(){
          if(!destroyed&&!paused&&visible&&!document.hidden&&index < source.length&&!frame)frame=requestAnimationFrame(tick);
        }
        function complete(){stop();index=source.length;paint();labels();}
        controls.hidden=motion.matches;
        if(motion.matches)complete();else{paint();labels();}
        if('IntersectionObserver' in window){
          observer=new IntersectionObserver(function(entries){
            visible=entries[0].isIntersecting;
            if(visible){started=true;labels();resume();}else stop();
          },{threshold:0});
          observer.observe(root);
        }else{visible=true;started=true;labels();resume();}
        pause.addEventListener('click',function(){paused=!paused;labels();if(paused)stop();else resume();},{signal:events.signal});
        replay.addEventListener('click',function(){stop();index=0;budget=0;paused=false;started=true;paint();labels();resume();},{signal:events.signal});
        document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else resume();},{signal:events.signal});
        motion.addEventListener('change',function(){controls.hidden=motion.matches;if(motion.matches)complete();},{signal:events.signal});
        root.nviCleanup=function(){destroyed=true;stop();events.abort();if(observer)observer.disconnect();code.textContent=source;delete root.nviCleanup;};
      });
    };
    document.addEventListener('shopify:section:load',function(event){window.nuvantaCodeInit(event.target);});
    document.addEventListener('shopify:section:unload',function(event){
      const roots=Array.from(event.target.querySelectorAll('[data-nvi]'));
      if(event.target.matches&&event.target.matches('[data-nvi]'))roots.push(event.target);
      roots.forEach(function(root){if(root.nviCleanup)root.nviCleanup();});
    });
  }
  window.nuvantaCodeInit(document);
})();
;
(() => {
  if (window.nuvantaProcess) { window.nuvantaProcess.init(document); return; }
  const instances = new Map();
  const init = (scope) => {
    const roots = [...scope.querySelectorAll('[data-nvp]')];
    if (scope.matches && scope.matches('[data-nvp]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const steps = root.querySelector('.nvp__steps');
      const cards = [...root.querySelectorAll('.nvp__card')];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let frame = 0;
      const update = () => {
        frame = 0;
        const rect = steps.getBoundingClientRect();
        const viewport = window.innerHeight;
        const progress = Math.max(0,Math.min(1,(viewport * .78 - rect.top) / Math.max(1,rect.height)));
        root.style.setProperty('--progress',progress.toFixed(4));
        cards.forEach((card) => card.classList.toggle('nvp-passed',card.getBoundingClientRect().top < viewport * .78));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const visible = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          root.classList.toggle('nvp-visible',entry.isIntersecting);
          if (entry.isIntersecting) schedule();
        });
      },{threshold:0}) : null;
      const reveal = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (!reduced.matches && entry.target.animate) entry.target.animate([{opacity:.35,transform:'translateY(24px)'},{opacity:1,transform:'translateY(0)'}],{duration:800,easing:'cubic-bezier(.22,1,.36,1)',delay:window.innerWidth >= 1100 ? cards.indexOf(entry.target)*80 : 0});
          reveal.unobserve(entry.target);
        });
      },{threshold:.12}) : null;
      const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      const destroy = () => {
        if (frame) cancelAnimationFrame(frame);
        window.removeEventListener('scroll',schedule);
        window.removeEventListener('resize',schedule);
        if (visible) visible.disconnect();
        if (reveal) reveal.disconnect();
        if (resize) resize.disconnect();
        instances.delete(root);
      };
      instances.set(root,destroy);
      if (visible) visible.observe(root);
      if (reveal) cards.forEach((card) => reveal.observe(card));
      if (resize) resize.observe(steps);
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule,{passive:true});
      schedule();
    });
  };
  window.nuvantaProcess = {init};
  init(document);
  document.addEventListener('shopify:section:load',(event) => init(event.target));
  document.addEventListener('shopify:section:unload',(event) => {
    instances.forEach((destroy,root) => { if (event.target === root || event.target.contains(root)) destroy(); });
  });
})();
;
(() => {
    const init = (scope) => {
      scope.querySelectorAll('.nv-faq').forEach((root) => {
        if (root.dataset.nvReady) return;
        root.dataset.nvReady = 'true';
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const items = [...root.querySelectorAll('.nv-faq__item')];
        const controls = new Map();
        items.forEach((item) => {
          const summary = item.querySelector('summary');
          const panel = item.querySelector('.nv-faq__answer');
          let motion = null;
          let expanded = item.open;
          const setOpen = (next) => {
            const start = panel.getBoundingClientRect().height;
            if (motion) { motion.cancel(); motion = null; }
            expanded = next;
            if (reduced.matches || !panel.animate) { item.open = next; return; }
            item.open = true;
            const end = next ? panel.scrollHeight : 0;
            const current = panel.animate([{height:start+'px',opacity:start ? 1 : 0},{height:end+'px',opacity:next ? 1 : 0}], {duration:340,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
            motion = current;
            current.onfinish = () => { item.open = next; current.cancel(); if (motion === current) motion = null; };
          };
          controls.set(item,setOpen);
          summary.addEventListener('click',(event) => {
            event.preventDefault();
            const next = !expanded;
            if (next) items.forEach((other) => { if (other !== item && other.open) controls.get(other)(false); });
            setOpen(next);
          });
        });
        if ('IntersectionObserver' in window && !reduced.matches) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              if (entry.target.animate) entry.target.animate([{opacity:.5,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.22,1,.36,1)',delay:items.indexOf(entry.target)*55});
              observer.unobserve(entry.target);
            });
          },{threshold:.15});
          items.forEach((item) => observer.observe(item));
        }
      });
    };
    init(document);
    if (!window.nvFaqEditorBound) {
      window.nvFaqEditorBound = true;
      document.addEventListener('shopify:section:load',(event) => init(event.target));
    }
  })();